import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum SosBudgetLineItemKeys {
  itemNumber = 'itemNumber', // line item number, not to be entered by user
  description = 'description', // verbose description of the item (human parseable)
  image = 'image', // image of the item
  itemQty = 'itemQty', // quantity of the item for order
  unitCost = 'unitCost', // price per unit
  extendedCost = 'extendedCost', // extended cost per (unitCost * itemQty), not to be entered by user

  // Not shown per line item, instead used to group items in the UI
  category = 'category', // category of the item
}

export const sosBudgetFileDataSchema = yup.object().shape({
  date: yup.string().nullable().optional(),
  contactName: yup.string().nullable().optional(),
  title: yup.string().nullable().optional(),
  vendor: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        image: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        unitCost: yup.string().nullable().optional(),
        extendedCost: yup.string().nullable().optional(),
        category: yup.string().nullable().optional(),
      }),
    )
    .required(),
  taxRate: yup.string().nullable().optional(),
  freightFee: yup.string().nullable().optional(),
  tariffFee: yup.string().nullable().optional(),
  installationFee: yup.string().nullable().optional(),
  instructions: yup.string().nullable().optional(),
})

export type SosBudgetFileData = yup.InferType<typeof sosBudgetFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<SosBudgetFileData>

export const sosBudgetFileMappings: RequiredFileData = {
  vendor: {
    companyName: '199b8010-a569-46fa-b580-b3d2895f18ac',
    address: '0e4b5f58-367a-43d1-a990-0bf44f660bb5',
  },
  contactName: '82dc9b30-dd6c-42e6-80a1-ed14362bb85f',
  title: 'ad27cb3e-3251-45af-b019-9f5ebb4707cd',
  date: '15f7a541-2232-4125-91b3-dbfd734a6a81',
  items: [
    {
      itemNumber: null,
      image: '1a0bbfe5-4a23-4252-9c67-b130176c92d0',
      description: 'b89b3bd1-e632-40c7-98a0-0e44c4b421b2',
      itemQty: 'a1551ee9-c407-4e74-8f74-61294670afea',
      unitCost: '6ead47c3-ad53-4530-b106-245335040444',
      extendedCost: null,
      category: '329d8ea0-3b78-484d-809b-ab3a741783cf',
    },
  ],
  taxRate: '8bd83867-e35d-4b98-a749-0b6738c727e8',
  freightFee: 'd0a97318-2a3e-4f0c-9343-6e2fa068a13e',
  tariffFee: 'abe73f46-5b4d-46cd-9748-45a85e676193',
  installationFee: 'a578d220-809c-4e72-b010-4760b866e09d',
  instructions: 'e7b74e1e-b7fa-44cd-8ccd-38899f494f07',
}
